
import { FileListInputData } from './file-list-input-data';
import { ImageCropperService } from '../../../../image-cropper/image-cropper-service';
import * as $ from 'jquery';
import { stringify } from 'querystring';

export class FileListInputCommon {

    static fileData: Array<FileListInputData> = [];


    static getListItem(idx, file, attributes, name, copyrightInfo = '', cropper = false) {
        let error = file.error;
        let text = `<li><div><span class="file-name"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/></svg><span class="file-inner">${file.name}</span>${FileListInputCommon.addCropperIcon(file, cropper)}</span><div class="close" data-file-uid="${file.uid}">+</div></div><div>${FileListInputCommon.addCopyrightInput(attributes, name, idx, file.uid, copyrightInfo)}</div></li>`;
        if (error.min) {
            let errorMsg = attributes['data-min-size-error'] && attributes['data-min-size-error'].value ? attributes['data-min-size-error'].value : 'Error, minimum file size is not reached!';
            text = `<li class="error"><div><span class="file-name"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>&nbsp;${file.name}</span> <span class="error">${errorMsg}</span><div><div class="close" data-file-uid="${file.uid}">+</div></li>`;
        }
        if (error.max) {
            let errorMsg = attributes['data-max-size-error'] && attributes['data-max-size-error'].value ? attributes['data-max-size-error'].value : 'Error, file size exceeds limit!';
            text = `<li class="error"><div><span class="file-name"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>&nbsp;${file.name}</span> <span class="error">${errorMsg}</span><div><div class="close" data-file-uid="${file.uid}">+</div></li>`;
        }
        if (error.accepted) {
            let errorMsg = 'Error, file extension is not supported!';
            text = `<li class="error"><div><span class="file-name"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>&nbsp;${file.name}</span> <span class="error">${errorMsg}</span><div><div class="close" data-file-uid="${file.uid}">+</div></li>`;
        }
        return text;

    }

    static showBusy(file) {
        if (file.busy) {
            $(`.cropper-btn[data-file-uid="${file.uid}"]`).hide();
            $(`.spinner[data-file-uid="${file.uid}"]`).show();
        }
        else {
            $(`.cropper-btn[data-file-uid="${file.uid}"]`).show();
            $(`.spinner[data-file-uid="${file.uid}"]`).hide();
        }

    }


    static addCropperIcon(file, cropper) {
        return FileListInputData.isImage(file) && cropper ? `<i data-file-uid="${file.uid}" class="fa fa-scissors cropper-btn"></i><i data-file-uid="${file.uid}" class="fa fa-cog fa-spin spinner"></i>` : '';
    }


    static addCopyrightInput(attributes, fileInput, idx, uid, copyrightInfo) {
        return (attributes['data-show-copyright'] && attributes['data-show-copyright'].value == 'true') ? `<div><input type="text" data-file-uid="${uid}" value="${copyrightInfo}" name="${fileInput}_copyright_${idx}"></div>` : '';
    }


    static validateAll() {

        let i = 0;
        while (i < FileListInputCommon.fileData.length && FileListInputCommon.validate(FileListInputCommon.fileData[i].name)) {
            i++;
        }
        return i == FileListInputCommon.fileData.length;
    }

    static validate(name: string) {
        let files = FileListInputCommon.getFileInputData(name).getFiles();
        let i = 0;
        while (i < files.length && (files[i].base64Image || (!files[i].error.min && !files[i].error.max)) && !files[i].busy) {
            i++;
        }
        return i == files.length;

    }

    static reset(form) {

        $(`form[name=${form}] .file-uploader-list-component`).each((i, comp) => {
            $(comp).find('input').val('');
            $(comp).find('.copyright-title').hide();
            const name = $(comp).attr('data-fileinput-name');
            if (FileListInputCommon.getFileInputData(name))
                FileListInputCommon.getFileInputData(name).resetFiles();
        })
    }

    static updateList(fileInputData: FileListInputData) {

        const files = fileInputData.getFiles();
        let comp = $(`.file-uploader-list-component[data-fileinput-name="${fileInputData.name}"]`);
        let list = comp.find("ul.files-list");
        list.html("");
        let attributes = $(comp).get(0).attributes;
        if (attributes['data-show-copyright'] && attributes['data-show-copyright'].value == 'true') {
            comp.find('.copyright-title').show().text(attributes['data-copyright-title'].value);
        }
        else {
            comp.find('.copyright-title').hide();
        }

        $.each(files, (idx, file) => {
            let text = FileListInputCommon.getListItem(idx, file, attributes, name, file.copyrightInfo, attributes['data-cropper'].value == 'true');
            list.append(text);
            FileListInputCommon.showBusy(file);
        });

    }

    static getFileInputData(name: string) {
        const filtered = FileListInputCommon.fileData.filter(data => data.name === name);
        if (filtered.length > 0)
            return filtered[0];
        return null;
    }


    static getFiles(name: string) {
        const fileData: FileListInputData = this.getFileInputData(name);
        if (fileData)
            return fileData.getFiles();
        return null;
    }

    static getEventData(event) {
        const comp = $(event.target).closest('[data-fileinput-name]');
        const name = comp.attr('data-fileinput-name');
        if (name) {
            return FileListInputCommon.getFileInputData(name);
        }
        return null;
    }

    static cropperService: ImageCropperService;

    static initCrop(eventData: FileListInputData, uid, width, height) {
        if (!FileListInputCommon.cropperService) {
            FileListInputCommon.cropperService = new ImageCropperService();
        }
        eventData.getBase64Image(uid, FileListInputCommon.showBusy).then((b64: string) => {
            let file = eventData.getFileByUID(uid);
            file.busy = true;
            FileListInputCommon.showBusy(file);
            FileListInputCommon.cropperService.popupCropper(b64, file.type, eventData.getFileName(file.uid), file.serverName ? file.serverName : null, width, height)
                .then((result: { image: string, serverPath: string }) => {
                    if (result && result.image) {
                        file.base64Image = result.image;
                        file.serverName = result.serverPath

                    }
                    file.busy = false;
                    FileListInputCommon.showBusy(file);
                });
        });
    }

    static initFileUpload(comp) {
        const c = $(comp);
        const input = c.find('input[type="file"]');
        const name = input.attr('name');
        const attributes = $(comp).get(0).attributes;
        input.addClass('temporary-file-input');
        let inputData = new FileListInputData($('<div/>').append(input.clone()).html(), name, attributes);
        FileListInputCommon.fileData.push(inputData);
        c.attr('data-fileinput-name', name);
        c.off("click", "button.file-select");
        c.on("click", "button.file-select", ev => {
            const eventData = FileListInputCommon.getEventData(ev);
            if (eventData) {
                const fi = eventData.getInput();
                $('.temporary-file-input').remove();
                fi.appendTo('body');
                fi.change(event => {
                    eventData.addFiles(fi.prop("files"), FileListInputCommon.showBusy);
                    FileListInputCommon.updateList(eventData);
                    $('.temporary-file-input').remove();
                });
                fi.click()
            }
        });
        c.on('change', 'input[data-file-uid]', ev => {
            let uid = $(ev.target).closest('[data-file-uid]').attr('data-file-uid');
            const eventData = FileListInputCommon.getEventData(ev);
            eventData.addCopyrightInfo($(ev.target).val().toString(), uid);
        })
        //input.remove();
        c.on('click', '.close', ev => {
            let uid = $(ev.target).closest('[data-file-uid]').attr('data-file-uid');
            const eventData = FileListInputCommon.getEventData(ev);
            if (uid && eventData) {
                eventData.deleteFile(uid);
                FileListInputCommon.updateList(eventData);
            }
        })
        c.on('click', '.cropper-btn', ev => {
            const eventData = FileListInputCommon.getEventData(ev);
            let uid = $(ev.target).closest('[data-file-uid]').attr('data-file-uid');
            if (eventData && uid) {
                try {
                    let croppedWidth, croppedHeight;
                    const comp = $(ev.target).closest('[data-cropper]');
                    if (comp.length > 0) {
                        croppedWidth = comp.attr('data-cropped-width');
                        croppedHeight = comp.attr('data-cropped-height');
                    }
                    FileListInputCommon.initCrop(eventData, uid, croppedWidth, croppedHeight);
                }
                catch (ex) {
                    console.warn('Error initializing cropper', ex);
                }
            }
        })
        // (c as any).off("change", input.get(0));
        // c.on("change", input.get(0), event => {
        //     if ($(event.target).attr('type') == 'file') {
        //         const eventData = FileListInputCommon.getEventData(ev);
        //         if (eventData) {
        //         FileListInputCommon.addList(input);
        //     }
        // });
    }
}
